import {
  Users, UserCheck, LayoutDashboard, Package, DoorOpen, MessageSquare,
  BarChart2, Vote, Settings, Copy, Map, Share2, Shield, FileSpreadsheet, Star
} from 'lucide-react';

export const MENUS_POR_ROL = {
  superadmin: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Banco Talento',      path: '/talento',            icon: Star,            cat: 'operacion' },
    { label: 'Inventario',         path: '/inventario',         icon: Package,         cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
    { label: 'Auditoría',          path: '/auditoria',          icon: Shield,          cat: 'analisis' },
    { label: 'Organigrama',        path: '/organigrama',        icon: Share2,          cat: 'admin' },
    { label: 'Validación Excel',   path: '/validacion',         icon: FileSpreadsheet, cat: 'analisis' },
    { label: 'Admin',              path: '/admin',              icon: Settings,        cat: 'admin' },
  ],
  coordinador_general: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Banco Talento',      path: '/talento',            icon: Star,            cat: 'operacion' },
    { label: 'Inventario',         path: '/inventario',         icon: Package,         cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
    { label: 'Auditoría',          path: '/auditoria',          icon: Shield,          cat: 'analisis' },
    { label: 'Organigrama',        path: '/organigrama',        icon: Share2,          cat: 'admin' },
    { label: 'Validación Excel',   path: '/validacion',         icon: FileSpreadsheet, cat: 'analisis' },
    { label: 'Admin',              path: '/admin',              icon: Settings,        cat: 'admin' },
  ],
  coordinador_territorial: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin' },
    { label: 'Mis Promovidos',     path: '/mis-promovidos',     icon: UserCheck,       cat: 'operacion' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  coordinador_sectorial: [
    { label: 'Tablero',            path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin' },
    { label: 'Mis Promovidos',     path: '/mis-promovidos',     icon: UserCheck,       cat: 'operacion' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Reportes',           path: '/reportes-avanzados', icon: BarChart2,       cat: 'analisis' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  seccional: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  operador: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Usuarios',           path: '/usuarios',           icon: Users,           cat: 'admin' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  promotor: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
  ],
  auditor: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Toca y Promueve',    path: '/toca',               icon: DoorOpen,        cat: 'operacion' },
    { label: 'Duplicidades',       path: '/duplicidades',       icon: Copy,            cat: 'analisis' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
  ],
  responsable_inventario: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Inventario',         path: '/inventario',         icon: Package,         cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
  ],
  movilizador: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
    { label: 'Movilización',       path: '/movilizacion',       icon: Vote,            cat: 'operacion' },
    { label: 'Cobertura en Campo', path: '/cobertura',          icon: Map,             cat: 'operacion' },
  ],
  representante_casilla: [
    { label: 'Inicio',             path: '/dashboard',          icon: LayoutDashboard, cat: 'principal' },
    { label: 'Mi Casilla',         path: '/mi-casilla',         icon: Vote,            cat: 'operacion' },
    { label: 'Mensajería',         path: '/mensajeria',         icon: MessageSquare,   cat: 'operacion' },
  ],
};

export const CATEGORIAS = [
  { key: 'principal', label: 'Principal' },
  { key: 'operacion', label: 'Operación' },
  { key: 'analisis',  label: 'Análisis' },
  { key: 'admin',     label: 'Administración' },
];

// Colores por módulo para los íconos del dashboard tipo grid
export const COLORES_MODULOS = {
  '/toca':               'bg-verde-500',
  '/cobertura':          'bg-sky-500',
  '/duplicidades':       'bg-amber-500',
  '/talento':            'bg-yellow-500',
  '/inventario':         'bg-violet-500',
  '/mensajeria':         'bg-guinda-600',
  '/reportes-avanzados': 'bg-indigo-500',
  '/movilizacion':       'bg-rose-500',
  '/auditoria':          'bg-slate-600',
  '/organigrama':        'bg-teal-500',
  '/validacion':         'bg-cyan-500',
  '/admin':              'bg-slate-700',
  '/usuarios':           'bg-blue-500',
  '/mis-promovidos':     'bg-emerald-500',
  '/mi-casilla':         'bg-purple-500',
  '/dashboard':          'bg-guinda-600',
};
